import { Typography, Stack } from '@cast/design-system';

type Props = {
  cpu: string | number;
  memory: string | number;
  cpuSuffix?: string;
  memorySuffix?: string;
};

export const ResourcesCell = ({
  cpu,
  memory,
  cpuSuffix,
  memorySuffix,
}: Props) => {
  return (
    <Stack>
      <Typography variant="P10R" data-testid="resources-cell-cpu">
        CPU: {cpu} {cpuSuffix}
      </Typography>
      <Typography variant="P10R" data-testid="resources-cell-memory">
        Memory: {memory} {memorySuffix}
      </Typography>
    </Stack>
  );
};
